import React, { useEffect, useState } from 'react';
import { IPropertyWizardInput } from './NewPropertyWizard';
// import styles from "./AvailableFrom.scss";
import styles from './NewPropertyWizard.scss';
import Select from '../MaterialUi/Select';
import TextField from '../MaterialUi/TextField';
import Box from '@mui/material/Box';
import Grow from '@mui/material/Grow';
import { TransitionGroup } from 'react-transition-group/dist/react-transition-group.js';

export interface IAvailableFromProps extends IPropertyWizardInput {
    // text: string;
}

function limit(val, max) {
    if (val.length === 1 && val[0] > max[0]) {
        val = '0' + val;
    }

    if (val.length === 2) {
        if (Number(val) === 0) {
            val = '01';

            //this can happen when user paste number
        } else if (val > max) {
            val = max;
        }
    }

    return val;
}

// const dateFormat = (val) => {
//     let day = limit(val.substring(0, 2), 31);
//     let month = limit(val.substring(2, 4), '12');
//     let year = val.substring(4, 8);
//     // let [day, month, year] = val.split(/[\D]/);
//     // day = limit(day, 31);

//     return day + (day?.length ? '.' : '') + (month ? month : '') + (month?.length ? '.' : '') + (year ? year : '');
// };

const isOwnText = (text) => {
    return (
        text !== null && typeof text !== 'undefined' && text != 'text' && text !== 'sofort' && text !== 'nach Vereinbarung' && text !== 'date' && text !== ''
    );
};

const AvailableFrom: React.FC<React.PropsWithChildren<IAvailableFromProps>> = ({ step = null, data = null, onChange = () => {} }) => {
    const [currSelect, setCurrSelect] = useState<string>(isOwnText(data.available_from_text) ? 'text' : data.available_from_text || '');

    const [nextData, setNextData] = useState(data); // for showing internal state without rerendering complete parent component

    useEffect(() => {
        setNextData(data);
    }, [data]);

    // const handleChange = (name: IStep['name'], value: string) => {
    const handleSelectChange = (ev) => {
        const name = ev.target.name;
        const value = ev.target.value;

        setCurrSelect(value);
        if (value !== 'date') {
            onChange('available_from_date', null);
        }
        onChange('available_from_text', value);
    };

    // const handleSelectChange = (name: string, value: string) => {
    //     setCurrSelect(value);
    //     if (value !== 'date') {
    //         onChange('available_from_date', null);
    //     }
    //     onChange('available_from_text', value);
    // };

    const handleDateChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        setNextData({ ...nextData, available_from_date: ev.target.value });
        onChange('available_from_date', ev.target.value);
    };

    // const handleDateChange = (date) => {
    //     onChange('available_from_date', date);
    // };
    const handleTextChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        setNextData({ ...nextData, [ev.target.name]: ev.target.value });
        onChange('available_from_text', ev.target.value);
    };

    const showTextField = currSelect === 'text' || isOwnText(nextData.available_from_text);

    const input = step.inputs.find((i) => true);

    return (
        <div className={styles.availableFrom}>
            <Select label={input.title} key={input.name} name={input.name} value={currSelect} onChange={handleSelectChange}>
                {Object.keys(input.options).map((key) => {
                    const o = input.options[key];

                    return (
                        <option key={key} value={key}>
                            {o}
                        </option>
                    );
                })}
            </Select>

            <TransitionGroup>
                {currSelect === 'date' && (
                    <Grow>
                        <Box>
                            <TextField
                                inputProps={{
                                    min: `${new Date().getFullYear()}-01-01`,
                                    max: `${new Date().getFullYear() + 2}-12-31`,
                                }}
                                value={data.available_from_date || ''}
                                type="date"
                                onChange={handleDateChange}
                            ></TextField>
                        </Box>
                    </Grow>
                )}
            </TransitionGroup>

            {showTextField && (
                <div className="input-field">
                    <label>Bezugsfrei ab</label>
                    <input defaultValue={isOwnText(nextData.available_from_text) ? nextData.available_from_text : ''} onChange={handleTextChange} />
                </div>
            )}
        </div>
    );
};

export default AvailableFrom;
